import Header from '../components/Header';
import LiveRates from '../components/LiveRates';

export default function LiveRatesPage() {
  return (
    <>
      <Header title="Live Rates" showBack={true} />
      <LiveRates marketLabel="Local Market" useLiveApi={true} />
    </>
  );
}

